const getAlignmentClassName = (alignment, classes) => {
  switch (alignment) {
    case 'left':
      return 'isLeftAligned' in classes && classes.isLeftAligned;
    case 'right':
      return 'isRightAligned' in classes && classes.isRightAligned;
    case 'center':
      return 'isCenterAligned' in classes && classes.isCenterAligned;
    default:
      return false;
  }
};
export default getAlignmentClassName;